import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Icon, Typography } from '@elements';
import { Box, Dialog, Slide } from '@mui/material';
import React, { useContext } from 'react';
import Close from '@images/close.svg';
import { StyledIconButton } from '@elements/icon-button/icon-button.styles';
import { QRCodeSVG } from 'qrcode.react';
import { ProfileContext } from '@contexts';
import { useDeviceSize } from '@hooks/useDeviceSize';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Transition = /*#__PURE__*/React.forwardRef(function Transition(props, ref) {
  return /*#__PURE__*/_jsx(Slide, _objectSpread({
    direction: "up",
    ref: ref
  }, props));
});
var TicketQr = function TicketQr(_ref) {
  var isOpen = _ref.isOpen,
    handleClose = _ref.handleClose,
    barcode = _ref.barcode,
    sector_prefix = _ref.sector_prefix,
    sector = _ref.sector,
    line_prefix = _ref.line_prefix,
    line = _ref.line,
    seat_prefix = _ref.seat_prefix,
    seat = _ref.seat;
  var profile = useContext(ProfileContext);
  var _useDeviceSize = useDeviceSize(),
    mobile = _useDeviceSize.mobile;
  return /*#__PURE__*/_jsxs(Dialog, {
    open: isOpen,
    TransitionComponent: Transition,
    keepMounted: true,
    onClose: handleClose,
    "aria-describedby": "alert-dialog-slide-description",
    slotProps: {
      backdrop: {
        sx: {
          backdropFilter: 'blur(6px)'
        }
      }
    },
    PaperProps: {
      sx: {
        borderRadius: {
          xs: 0,
          md: '12px'
        },
        minWidth: {
          xs: 'auto',
          md: '352px'
        },
        paddingTop: '16px',
        paddingLeft: '48px',
        paddingRight: '20px',
        paddingBottom: '70px'
      }
    },
    fullScreen: mobile,
    children: [/*#__PURE__*/_jsxs(Box, {
      sx: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
      },
      children: [/*#__PURE__*/_jsx(Typography, {
        fontSize: 22,
        fontWeight: 400,
        children: "QR-Code"
      }), /*#__PURE__*/_jsx(StyledIconButton, {
        onClick: function onClick() {
          handleClose();
        },
        children: /*#__PURE__*/_jsx(Icon, {
          src: Close,
          width: 28,
          height: 28
        })
      })]
    }), /*#__PURE__*/_jsx(Box, {
      sx: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: '20px'
      },
      children: /*#__PURE__*/_jsx(QRCodeSVG, {
        value: barcode !== null && barcode !== void 0 ? barcode : '',
        size: 92
      })
    }), /*#__PURE__*/_jsxs(Box, {
      sx: {
        display: 'flex',
        justifyContent: 'space-between',
        marginTop: '40px'
      },
      children: [/*#__PURE__*/_jsxs(Box, {
        sx: {
          display: 'flex',
          flexDirection: 'column',
          rowGap: '16px'
        },
        children: [/*#__PURE__*/_jsx(Typography, {
          color: "silver",
          fontSize: 14,
          children: "\u041C\u0435\u0441\u0442\u043E"
        }), !!sector && /*#__PURE__*/_jsx(Typography, {
          fontSize: 14,
          children: /*#__PURE__*/_jsxs("span", {
            style: {
              fontWeight: 500
            },
            children: [sector_prefix, " ", sector]
          })
        }), !!line && /*#__PURE__*/_jsx(Typography, {
          fontSize: 14,
          children: /*#__PURE__*/_jsxs("span", {
            style: {
              fontWeight: 500
            },
            children: [line_prefix, " ", line]
          })
        }), /*#__PURE__*/_jsx(Typography, {
          fontSize: 14,
          children: /*#__PURE__*/_jsxs("span", {
            style: {
              fontWeight: 500
            },
            children: [seat_prefix, " ", seat]
          })
        })]
      }), /*#__PURE__*/_jsxs(Box, {
        sx: {
          display: 'flex',
          flexDirection: 'column',
          rowGap: '16px'
        },
        children: [/*#__PURE__*/_jsx(Typography, {
          color: "silver",
          fontSize: 14,
          children: "\u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C"
        }), /*#__PURE__*/_jsxs(Box, {
          children: [/*#__PURE__*/_jsx(Typography, {
            fontSize: 14,
            children: profile === null || profile === void 0 ? void 0 : profile.firstName
          }), /*#__PURE__*/_jsx(Typography, {
            fontSize: 14,
            children: profile === null || profile === void 0 ? void 0 : profile.lastName
          })]
        })]
      })]
    })]
  });
};
export default TicketQr;